var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStackHorizontal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "stack-horizontal-a",
    d: "M30,6 L42,6 C43.1045695,6 44,6.8954305 44,8 L44,20 C44,21.1045695 43.1045695,22 42,22 L30,22 C28.8954305,22 28,21.1045695 28,20 L28,8 C28,6.8954305 28.8954305,6 30,6 Z M30,28 L42,28 C43.1045695,28 44,28.8954305 44,30 L44,42 C44,43.1045695 43.1045695,44 42,44 L30,44 C28.8954305,44 28,43.1045695 28,42 L28,30 C28,28.8954305 28.8954305,28 30,28 Z M30,50 L42,50 C43.1045695,50 44,50.8954305 44,52 L44,64 C44,65.1045695 43.1045695,66 42,66 L30,66 C28.8954305,66 28,65.1045695 28,64 L28,52 C28,50.8954305 28.8954305,50 30,50 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(90 36 36)",
    xlinkHref: "#stack-horizontal-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStackHorizontal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stack-horizontal.69f1d6e9bda054b5052d123bc9b33db6.svg";